import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import { tokenDecode } from "../../../utils/helper";
import shikharapplogo from "../../../icons/logoimg.png"
import styles from "./navbar.module.css"
import bars from "../../../icons/MenuBar.png"
import shop from "../../../icons/shop.png"
import PublicIcon from '@mui/icons-material/Public';

const Navbar = (props) => {
    const history = useHistory();
    const logoutExecutedRef = useRef(false);
    const logoutTimerRef = useRef(null);

    const token = sessionStorage.getItem("us_st_d");
    const decoded = tokenDecode();
    const { data } = decoded;
    const { user } = data;

    const logouthandler = useCallback(() => {
        sessionStorage.removeItem('us_st_d');
    }, []);

    const handleLogout = useCallback(() => {
        if (!logoutExecutedRef.current) {
            logoutExecutedRef.current = true;
            logouthandler();
            history.push('/');
        }
    }, [history, logouthandler]);

    useEffect(() => {
        const decoded = token && tokenDecode(token);
        const expirationTime = decoded?.exp * 1000;
        // const expirationDateTime = new Date(decoded.exp * 1000);
        // console.log('Token expired on:', expirationDateTime);
        if (expirationTime) {
            const delay = expirationTime - Date.now();
            logoutTimerRef.current = setTimeout(handleLogout, delay);
        } else {
            logouthandler();
        }

        return () => {
            clearTimeout(logoutTimerRef.current);
        };
    }, [token, handleLogout, logouthandler, history]);


    return (
        <>
            <div style={{ display: "flex", width: "100%" }}>
                <div ></div>
                <nav className={`navbar navbar-expand navbar-light topbar static-top ${styles.mobile_navbar}`} style={{ width: "100%" }}>
                    {/* <Link to="/">  */}
                    <button id="sidebarToggleTop" className={`btn btn-link rounded-circle mr-3 ${styles.burgerButton}`} onClick={() => props.Showmenu()}>
                        <img src={bars} alt="" style={{ height: "70%" }} />
                    </button>
                    {/* </Link> */}

                    {/* <Link to="/"> <div className={styles.logo}>  <img src={shikharapplogo} alt="" /> SHIKHAR SELLER APP </div></Link> */}
                    {/* <div className={styles.logo}>  <img src={shikharapplogo} alt="" /> SHIKHAR SELLER APP </div> */}

                    <ul className="navbar-nav  ">

                        {/* below is thesearch button of navbar start, uncomment when required */}


                        <div className="topbar-divider d-none d-sm-block"></div>
                        {/* {user.seller_id !== 1 ? <Link to="/sellerdetail?tab=shopdetails"  >
                        <a href="replace" className="dropdown-item" data-toggle="modal" data-target="#logoutModal">
                           
                            <img src={shop} alt="" />
                          
                        </a>
                    </Link>
                     : */}
                        <li className={`nav-item dropdown no-arrow ${styles.plus}`} >

                            <Link to="#" className="nav-link dropdown-toggle" id="userDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">{user?.name}</span>
                                <img className={`img-profile rounded-circle ${styles.dropdownimg}`}
                                    src={`/img/undraw_profile.svg`} alt="im here" />

                                <div className={styles.searchOpener}>
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                </div>

                            </Link>

                            <div className={`dropdown-menu  shadow animated--grow-in p-0 w-100 ${styles.dropDownPosition}`}
                                aria-labelledby="userDropdown">
                                <div className={styles.doropdownnavmenu}>
                                    {/* <Link to="/profile" >
                                    <a href="replace" className="dropdown-item" >
                                        <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                        <span> Profile  </span>
                                    </a>
                                </Link>

                                <div className="dropdown-divider"></div> */}
                                    <Link to="/sellerdetail?tab=shopdetails"  >
                                        <a href="replace" className={`dropdown-item ${styles.bottomPadding}`} data-toggle="modal" data-target="#logoutModal" >
                                            <i className="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>
                                            {/* <img src={shop} alt="" className={`${styles.shopDetailsImg}`} /> */}
                                            {/* <i className="fas fa-shop"></i> */}
                                            <span> Shop details </span>
                                        </a>
                                    </Link>

                                    <div className="dropdown-divider"></div>
                                    <Link to="/serviceability"  >
                                        <a href="replace" className={`dropdown-item ${styles.bottomPadding}`} data-toggle="modal" data-target="#logoutModal" >
                                            {/* <PublicIcon  sx={{ fontSize: 15, color: "lightgray" }} className={`mr-2 ${styles.servicabilityIcon}`}></PublicIcon> */}
                                            {/* <img src={shop} alt="" className={`${styles.shopDetailsImg}`} /> */}
                                            <i className="fa fa-globe fa-sm fa-fw mr-2 text-gray-400"></i>
                                            <span> Serviceability </span>
                                        </a>
                                    </Link>

                                    <div className="dropdown-divider"></div>
                                    <Link to="/updatepassword"  >
                                        <a href="replace" className={`dropdown-item ${styles.bottomPadding}`} data-toggle="modal" data-target="#logoutModal">
                                            <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                                            <span> Update Password </span>
                                        </a>
                                    </Link>

                                    {/* code as per new figma start */}

                                    {/* <div className="dropdown-divider"></div> */}
                                    {/* <Link to="#" onClick={logouthandler} > */}
                                    {/* <Link to="/notifications" className="dropdown-item" data-toggle="modal" data-target="#logoutModal">
                                    <i className="far fa-bell"></i>
                                    <span> Notifications </span>
                                </Link> */}
                                    {/* </Link> */}
                                    <div className="dropdown-divider"></div>

                                    <Link to="#" onClick={logouthandler} >
                                        <a href="replace" className={`dropdown-item ${styles.bottomPadding}`} data-toggle="modal" data-target="#logoutModal">
                                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                            <span> Logout </span>
                                        </a>
                                    </Link>


                                    {/* code as per new figma end */}
                                </div>
                            </div>



                        </li>
                        {/* } */}

                    </ul>

                </nav>
            </div>
        </>
    )
}

export default Navbar;
